// import helpers and components
import { NextHeadSEO } from '@components/common'
import { IDeviceInfo, useUI } from '@components/ui/context'
import { IImage } from '@components/utils/model/product.model'
import { IProductResponseWithResultArray } from './helpers/productResponse.model'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'
import withDataLayer, { PAGE_TYPES } from '@components/withDataLayer'
import { LayoutWithTopStrip } from '@components/common/Layout'
import MenCollectionView from './MensCollection.component'
import { generateUri } from '@commerce/utils/uri-util'
import CollectionSlider from '@components/collection'
import IntersectionObserverComponent, {
  IBannerData,
} from '@components/utils/IntersectionObserverComponent'
import { IMG_PLACEHOLDER } from '@components/utils/textVariables'
import { getCurrentPage, getImageNameFromURL } from '@framework/utils/app-util'
import { GA_EVENT } from 'hooks/ga_event.modal'
import Link from 'next/link'
import { useState, useEffect } from 'react'
import { EmptyGuid } from '@components/utils/constants'
import { MO_ENGAGE_EVENT } from 'hooks/moengage_event.modal'

interface IProps {
  deviceInfo: IDeviceInfo
  previousPath: string
  id: string
  products: IProductResponseWithResultArray
  allowFacets: boolean
  name: string
  completeSlug:string
  description: string
  customLinks: string
  customInfo1: string
  customInfo2: string
  customInfo3: string
  hostName: string
  metaTitle: string
  metaKeywords: string
  metaDescription: string
  images: IImage[]
}

function MenCollectionPage(props: IProps) {
  const {
    deviceInfo,
    previousPath,
    id,
    products,
    allowFacets,
    name,
    completeSlug,
    description,
    customLinks,
    customInfo1,
    hostName,
    metaTitle,
    metaKeywords,
    metaDescription,
    customInfo3,
    images,
    customInfo2,
  } = props
  const { user } = useUI()
  const [mid1Banners, setMid1Banners] = useState<Array<any>>([])
  const [mid2Banners, setMid2Banners] = useState<Array<any>>([])
  const [mid3Banners, setMid3Banners] = useState<Array<any>>([])
  const [paddingTop, setPaddingTop] = useState('0')
  const { isOnlyMobile } = deviceInfo

  const bannerClick = (img: IBannerData) => {
    trackMoEngageEvent(
      MO_ENGAGE_EVENT.BANNER_CLICK,
      {
        ...img,
        previous_page_url: window?.location?.href,
        URL: name,
      },
      window
    )
    const currentPage = getCurrentPage()
    if (currentPage) {
      recordGA4Event(window, GA_EVENT.BANNER_CLICK, {
        ...img,
        current_page: currentPage,
        loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
      })
    }
  }

  // const handleBannerImages = () => {
  //   if (images?.length > 0) {
  //     const _mid1Banners = images
  //       ?.filter(
  //         (item: any) =>
  //           item?.subTitle?.toLowerCase() === 'mid1-single' ||
  //           item?.subTitle?.toLowerCase() === 'mid1-multiple'
  //       )
  //       ?.sort((a: any, b: any) => a.displayOrder - b.displayOrder)

  //     const _mid2Banners = images
  //       ?.filter(
  //         (item: any) =>
  //           item?.subTitle?.toLowerCase() === 'mid2-single' ||
  //           item?.subTitle?.toLowerCase() === 'mid2-multiple'
  //       )
  //       ?.sort((a: any, b: any) => a.displayOrder - b.displayOrder)

  //     const _mid3Banners = images
  //       ?.filter(
  //         (item: any) =>
  //           item?.subTitle?.toLowerCase() === 'mid3-single' ||
  //           item?.subTitle?.toLowerCase() === 'mid3-multiple'
  //       )
  //       ?.sort((a: any, b: any) => a.displayOrder - b.displayOrder)

  //     setMid1Banners(_mid1Banners)
  //     setMid2Banners(_mid2Banners)
  //     setMid3Banners(_mid3Banners)
  //   }
  // }
  // useEffect(() => {
  //   handleBannerImages()
  // }, [JSON.stringify(images)])

  const _topBanners = images
    ?.filter(
      (item: any) =>
        !item?.subTitle || item?.subTitle === null || item?.subTitle === ''
    )
    ?.sort((a: any, b: any) => a.displayOrder - b.displayOrder)

  const _mid1Banners = images
    ?.filter(
      (item: any) =>
        item?.subTitle?.toLowerCase() === 'mid1-single' ||
        item?.subTitle?.toLowerCase() === 'mid1-multiple'
    )
    ?.sort((a: any, b: any) => a.displayOrder - b.displayOrder)

  const _mid2Banners = images
    ?.filter(
      (item: any) =>
        item?.subTitle?.toLowerCase() === 'mid2-single' ||
        item?.subTitle?.toLowerCase() === 'mid2-multiple'
    )
    ?.sort((a: any, b: any) => a.displayOrder - b.displayOrder)

  const _mid3Banners = images?.filter(
    (item: any) =>
      item?.subTitle?.toLowerCase() === 'mid3-single' ||
      item?.subTitle?.toLowerCase() === 'mid3-multiple'
  )
  return (
    <div>
      {hostName && <input className="inst" type="hidden" value={hostName} />}
      <NextHeadSEO
        seoSettings={{
          ...props,
          title: metaTitle,
          keywords: metaKeywords,
          description: metaDescription,
        }}
      />
      <main className="pb-0">
        <div className="">
          {customInfo3 == null ||
            (customInfo3 == '' && (
              <>
                <CollectionSlider
                  props={{ ...props, topBanners: _topBanners }}
                  sliderCount={1}
                  mobileSliderCount={1}
                  deviceInfo={deviceInfo}
                />
              </>
            ))}
          {customInfo3 == 'Horizontal' ||
            (customInfo3 == 'horizontal' && (
              <>
                <CollectionSlider
                  props={{
                    ...props,
                    topBanners: _topBanners,
                  }}
                  sliderCount={4}
                  mobileSliderCount={1.1}
                  deviceInfo={deviceInfo}
                />
              </>
            ))}
          {customInfo3 == 'vertical' && (
            <>
              <div className="container flex items-center justify-center w-full px-0 mx-auto mt-0 lg:px-6 sm:px-0 sm:mt-4">
                {_topBanners?.length > 1 ? (
                  <div className="w-full v-image-space">
                    {_topBanners?.map((img: any, idx: number) => {
                      const imgUrl =
                        (isOnlyMobile ? img?.mobileUrl : img?.url) || img?.url
                      let componentType = 'image'
                      if (img.gif) componentType = 'gif'
                      else if (img.video) componentType = 'video'
                      const bannerData: IBannerData = {
                        position: idx + 1,
                        banner_name: imgUrl ? getImageNameFromURL(imgUrl) : '',
                        component_type: componentType,
                        component_name: 'Collection Banner',
                        url: imgUrl ?? '',
                      }
                      return (
                        <div key={`collection-banner-1-${idx}`}>
                          <div className="relative w-full h-auto px-0 collection-multi-vimage">
                            <IntersectionObserverComponent
                              title="Collection Banner"
                              eventName={GA_EVENT.BANNER_IMPRESSIONS}
                              bannerData={bannerData}
                            >
                              <Link
                                legacyBehavior
                                href={img?.link || '#'}
                                passHref
                              >
                                <span
                                  onClick={() => bannerClick(bannerData)}
                                  style={{ paddingTop }}
                                  className="block w-full"
                                >
                                  <img
                                    src={
                                      generateUri(imgUrl, 'h=1060&q=50') ||
                                      IMG_PLACEHOLDER
                                    }
                                    alt="Collection Banner"
                                    className="w-full"
                                    onLoad={({ target }) => {
                                      const { naturalWidth, naturalHeight } =
                                        target as HTMLImageElement
                                      setPaddingTop(
                                        `calc(100% / (${naturalWidth} / ${naturalHeight})`
                                      )
                                    }}
                                  />
                                </span>
                              </Link>
                              <div
                                className="absolute z-10 text-left bottom-3 left-4"
                                onClick={() => bannerClick(bannerData)}
                              >
                                <h3 className="font-medium text-white text-14">
                                  {img?.title}
                                </h3>
                                <p className="mb-2 font-normal text-left text-white text-10">
                                  {img?.description}
                                </p>
                                {img?.title ? (
                                  <>
                                    <Link
                                      legacyBehavior
                                      href={img?.link}
                                      passHref
                                    >
                                      <span className="font-medium text-left text-white underline text-12">
                                        Shop now
                                      </span>
                                    </Link>
                                  </>
                                ) : null}
                              </div>
                            </IntersectionObserverComponent>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                ) : (
                  _topBanners?.map((img: any, idx: number) => {
                    const imgUrl =
                      (isOnlyMobile ? img?.mobileUrl : img?.url) || img?.url
                    let componentType = 'image'
                    if (img.gif) componentType = 'gif'
                    else if (img.video) componentType = 'video'
                    const bannerData: IBannerData = {
                      position: idx + 1,
                      banner_name: imgUrl ? getImageNameFromURL(imgUrl) : '',
                      component_type: componentType,
                      component_name: 'Collection Banner',
                      url: imgUrl ?? '',
                    }
                    return (
                      <div
                        className="w-full h-auto px-0"
                        key={`collection-banner-2-${idx}`}
                      >
                        <IntersectionObserverComponent
                          title="Collection Banner"
                          eventName={GA_EVENT.BANNER_IMPRESSIONS}
                          bannerData={bannerData}
                        >
                          <Link
                            legacyBehavior
                            href={img?.link || '#'}
                            className="w-full"
                          >
                            <a
                              onClick={() => {
                                bannerClick(bannerData)
                              }}
                            >
                              <img
                                src={imgUrl}
                                alt="banner"
                                className="w-full"
                              />
                            </a>
                          </Link>
                        </IntersectionObserverComponent>
                      </div>
                    )
                  })
                )}
              </div>
            </>
          )}
        </div>

        <MenCollectionView
          deviceInfo={deviceInfo}
          previousPath={previousPath}
          id={id}
          completeSlug={completeSlug}
          products={products}
          allowFacets={!!allowFacets}
          name={name}
          description={description}
          customLinks={customLinks}
          customInfo1={customInfo1}
          customInfo2={customInfo2}
          customInfo3={customInfo3}
          images={images}
          mid1Banners={_mid1Banners}
          mid2Banners={_mid2Banners}
          mid3Banners={_mid3Banners}
        />
      </main>
    </div>
  )
}

MenCollectionPage.Layout = LayoutWithTopStrip
export default withDataLayer(
  MenCollectionPage,
  PAGE_TYPES.Product,
  true,
  LayoutWithTopStrip
)
function trackMoEngageEvent(
  BANNER_CLICK: any,
  arg1: {
    previous_page_url: string
    URL: string
    position: number
    banner_name: string
    component_type: string
    component_name: string
    url?: string | undefined
    device?: string | undefined
    mid_banner_position?: number | undefined
  },
  window: Window & typeof globalThis
) {
  throw new Error('Function not implemented.')
}

function recordGA4Event(
  window: Window & typeof globalThis,
  BANNER_CLICK: GA_EVENT,
  arg2: {
    current_page: any
    loggedin_status: boolean
    position: number
    banner_name: string
    component_type: string
    component_name: string
    url?: string | undefined
    device?: string | undefined
    mid_banner_position?: number | undefined
  }
) {
  throw new Error('Function not implemented.')
}
